import BaseNavBar from "./BaseNavBar";
import { getCountry } from "./CountryUtil";

function NavBar(props) {
  return (
    <header>
      <div className="header-top">
        
        <BaseNavBar {...props} active='home'  />
        <section className="slider_section">
          <div id="myCarousel" className="carousel slide" data-ride="carousel">
            <ol className="carousel-indicators">
              <li data-target="#myCarousel" data-slide-to="0" className="active"></li>
              <li data-target="#myCarousel" data-slide-to="1"></li>
              <li data-target="#myCarousel" data-slide-to="2"></li>
            </ol>
            <div className="carousel-inner">
              <div className="carousel-item active">

                <div className="container">
                  <div className="carousel-caption">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="text-bg">
                          <span>News</span>
                          <h1>{getCountry(props.match.params.siteid).appName}</h1>
                          <p>The only news app you will ever need </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="carousel-item">

                <div className="container">
                  <div className="carousel-caption">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="text-bg">
                          <h1>User Experience</h1>
                          <p>Optimized for ease of use</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <a className="carousel-control-prev" href="#myCarousel" role="button" data-slide="prev">
              <i className="fa fa-long-arrow-left" aria-hidden="true"></i>

            </a>
            <a className="carousel-control-next" href="#myCarousel" role="button" data-slide="next">
              <i className="fa fa-long-arrow-right" aria-hidden="true"></i>

            </a>
          </div>



        </section>
      </div>
    </header>
  );
}

export default NavBar;
